<div class="inicio"><br>
    

    <mat-tab-group (selectedIndexChange)="myTabSelectedIndexChange($event)">
    
        <mat-tab label="EN ESPERA">   
            <br>
            <p class="titulo">
                SOLICITUDES DE EQUIPO
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon> 
                </button>
            </p>
            <br>

            <div class="inicio">
                   
                    <div class="grid-container2">
                        <div class="celda">
                            
                            <mat-form-field appearance="fill" floatLabel="always">
                                <mat-label>Buscar</mat-label>
                                <input matInput (keyup)="filtroDataP($event)"  placeholder="Ingrese un dato a buscar">
                            </mat-form-field>
                        </div>
                    </div>

                    <table mat-table [dataSource] = "dataSourceP" class="mat-elevation-z8">
        
                        <!-- Position Column -->
                        <ng-container matColumnDef="OPCIONES">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab color="accent" matTooltip="Ver solicitud a detalle" (click)="clickVerDetalle(element.id_solicitud_asig_equipo)"> <mat-icon >visibility</mat-icon> </button>
                            </td>
                        </ng-container>
            
                        <!-- Name Column -->
                        <ng-container matColumnDef="SOLICITANTE">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                        </ng-container>
                        
                        <!-- Name Column -->
                        <ng-container matColumnDef="COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                        </ng-container>
            
                        <!-- Name Column -->
                        <ng-container matColumnDef="CARGO DEL COLABORADOR">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                            <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                        </ng-container>
            
                        <!-- Name Column -->
                        <ng-container matColumnDef="EQUIPO SOLICITADO">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                            <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                        </ng-container>
            
                        <!-- Name Column -->
                        <ng-container matColumnDef="FECHA DE SOLICITUD">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD</th>
                            <td mat-cell *matCellDef="let element"> {{element.fecha_solicitud}} </td>
                        </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                        <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
                    
                    </table>

                    <mat-paginator #paginatorP class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

                
            </div>
        </mat-tab>
        
        <mat-tab label="ATENDIDAS "> 
            <br>
            <p class="titulo">
                SOLICITUDES DE EQUIPO
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon> 
                </button>
            </p>
            <br>

            <div class="inicio">
                <div class="grid-container2">
                    <mat-form-field  appearance="fill" floatLabel="always">
                        <mat-label>Buscar</mat-label>
                        <input matInput (keyup)="filtroDataA($event)"  placeholder="Ingrese un dato a buscar">
                    </mat-form-field>
                </div>
                <table mat-table [dataSource] = "dataSourceA" class="mat-elevation-z8">
    
                    <!-- Position Column -->
                    <ng-container matColumnDef="OPCIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-mini-fab color="accent" matTooltip="Ver solicitud a detalle" (click)="clickVerDetalle(element.id_solicitud_asig_equipo)"> <mat-icon >visibility</mat-icon> </button>
                        </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="STATUS">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> STATUS </th>
                        <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="SOLICITANTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                    </ng-container>
                    
                    <!-- Name Column -->
                    <ng-container matColumnDef="COLABORADOR">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="EQUIPO SOLICITADO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                        <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="FECHA DE ATENCIÓN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE ATENCIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_mod}} </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="encabezadostabla2"></tr>
                    <tr mat-row *matRowDef="let row; columns: encabezadostabla2"></tr>
                
                </table>
                <mat-paginator #paginatorA class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-tab>

        <mat-tab label="CANCELADAS">   
            <br>
            <p class="titulo">
                SOLICITUDES DE EQUIPO
                <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)">
                    <mat-icon>info</mat-icon> 
                </button>
            </p>
            <br>

            <div class="inicio">
                <div class="grid-container2">
                    <div class="celda">
                        
                        <mat-form-field  appearance="fill" floatLabel="always">
                            <mat-label>Buscar</mat-label>
                            <input matInput (keyup)="filtroDataC($event)"  placeholder="Ingrese un dato a buscar">
                        </mat-form-field>
                    </div>
                </div>
                <table mat-table [dataSource] = "dataSourceC" class="mat-elevation-z8">

                    <!-- Position Column -->
                    <ng-container matColumnDef="OPCIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-mini-fab color="accent" matTooltip="Ver solicitud a detalle" (click)="clickVerDetalle(element.id_solicitud_asig_equipo)"> <mat-icon >visibility</mat-icon> </button>
                        </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="SOLICITANTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                    </ng-container>
                    
                    <!-- Name Column -->
                    <ng-container matColumnDef="COLABORADOR">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="CARGO DEL COLABORADOR">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                        <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="EQUIPO SOLICITADO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> EQUIPO SOLICITADO </th>
                        <td mat-cell *matCellDef="let element"> {{element.tipo_equipo}} </td>
                    </ng-container>
        
                    <!-- Name Column -->
                    <ng-container matColumnDef="FECHA DE ATENCIÓN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE ATENCIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha_mod}} </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="encabezadostabla3"></tr>
                    <tr mat-row *matRowDef="let row; columns: encabezadostabla3;"></tr>
                
                </table>
                <mat-paginator #paginatorC class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-tab>

    </mat-tab-group>

</div>